import { supabase } from '../supabaseClient'

// Lo que el club necesita saber de los torneos donde participa.
//
// Todo por RPC: la RLS de `torneos` pide has_org_access de la propia org o de la
// organizadora, y un club invitado no tiene ninguna de las dos. Un SELECT normal
// devolveria vacio sin decir por que.

// Solo la lista (una vuelta). El resumen (proximo juego, inscripciones) va aparte con
// getResumenDeTorneos, para que la pantalla pinte la lista sin esperar la segunda vuelta.
export async function getMisTorneosDeLaRed() {
  try {
    const { data, error } = await supabase.rpc('get_mis_torneos_con_licencia')
    if (error) throw error
    return { data: (data || []).map((t) => ({ ...t, id: t.torneo_id, proximo: null, inscripciones: [] })), error: null }
  } catch (error) {
    console.error('[getMisTorneosDeLaRed]', error)
    return { data: [], error }
  }
}

// Lista + resumen en una sola llamada (dos vueltas al servidor). Se conserva para quien
// no necesite pintar por partes.
export async function getMisParticipaciones() {
  const { data: lista, error } = await getMisTorneosDeLaRed()
  if (error) return { data: [], error }
  if (lista.length === 0) return { data: [], error: null }
  const { data: res, error: e2 } = await getResumenDeTorneos(lista.map((t) => t.id))
  if (e2) return { data: [], error: e2 }
  return { data: aplicarResumen(lista, res), error: null }
}

export const aplicarResumen = (lista, res) => (lista || []).map((t) => ({
  ...t,
  proximo: res?.proximos?.get(t.id) || null,
  inscripciones: res?.inscripciones?.get(t.id) || [],
}))

// El mismo resumen, para los torneos que organiza el club. Los RPC no distinguen quien
// organiza -- preguntan por MI club -- asi que sirven igual para los dos mundos y las
// dos listas pueden verse iguales, que es justo el punto.
export async function getResumenDeTorneos(torneoIds = []) {
  if (!Array.isArray(torneoIds) || torneoIds.length === 0) {
    return { data: { proximos: new Map(), inscripciones: new Map() }, error: null }
  }
  try {
    const [proxRes, inscRes] = await Promise.all([
      supabase.rpc('get_proximo_juego_por_torneo', { p_torneo_ids: torneoIds }),
      supabase.rpc('get_mis_inscripciones_por_torneo', { p_torneo_ids: torneoIds }),
    ])
    if (proxRes.error) throw proxRes.error
    if (inscRes.error) throw inscRes.error

    const proximos = new Map((proxRes.data || []).map((p) => [p.torneo_id, p]))
    const inscripciones = new Map()
    ;(inscRes.data || []).forEach((i) => {
      if (!inscripciones.has(i.torneo_id)) inscripciones.set(i.torneo_id, [])
      inscripciones.get(i.torneo_id).push(i)
    })
    return { data: { proximos, inscripciones }, error: null }
  } catch (error) {
    console.error('[getResumenDeTorneos]', error)
    return { data: { proximos: new Map(), inscripciones: new Map() }, error }
  }
}
